import { render, staticRenderFns } from "./CPClientWatchlist.vue?vue&type=template&id=4b42c928&scoped=true&"
import script from "./CPClientWatchlist.vue?vue&type=script&lang=ts&"
export * from "./CPClientWatchlist.vue?vue&type=script&lang=ts&"
import style0 from "./CPClientWatchlist.vue?vue&type=style&index=0&id=4b42c928&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b42c928",
  null
  
)

export default component.exports